// extracted by mini-css-extract-plugin
export default {"modal":"dea-z","modalContent":"eea-z","footer":"fea-z","cancelBtn":"gea-z","disabled":"hea-z","formWrapper":"iea-z","fade":"jea-z","fade-in":"kea-z","iframe":"lea-z"};